import { cn } from '@foam/buoy/src/lib/utils';
import { Tooltip } from 'ui-components';
import { ISearchContentResult } from '~/searchApi';
import { isSafariBrowser } from '~/utils-ts';

import { getIsStoryExpired } from '../utils';
import { ContentCheckbox } from './ContentCheckbox';
import { ContentImageSection } from './ContentImageSection';
import { CreatorInfoSection } from './CreatorInfoSection';

interface Props {
  content: ISearchContentResult;
  onClick?: (content: ISearchContentResult) => void;
  isChecked?: boolean;
  isDraggable?: boolean;
  onCheckboxChange?: (checked: boolean) => void;
  isShared?: boolean;
  showMetrics?: boolean;
  interactive?: boolean;
}

export const ContentCard = ({
  content,
  onClick,
  isChecked = false,
  isDraggable = false,
  onCheckboxChange,
  isShared = false,
  showMetrics = false,
  interactive = true,
}: Props) => {
  const isSafari = isSafariBrowser();
  const isStoryExpired = getIsStoryExpired(content);
  const tooltipLabel = isStoryExpired
    ? "Sorry, this content link isn't available from Instagram"
    : '';

  return (
    <Tooltip label={tooltipLabel} hasArrow data-testid="content-tooltip">
      <div
        className={cn(
          'group relative overflow-hidden rounded-8 bg-[var(--media-kit-background-primary)] h-full border border-[var(--media-kit-background-alpha)]',
          {
            'border-orange-500': isChecked,
            'hover:border-neutral-300': isDraggable,
            'cursor-pointer': interactive,
            'flex flex-col justify-stretch': !isSafari, // Safari has issues with flexbox inside a "flex grow" container
          },
        )}
        data-testid="content-item"
        onClick={(e) => {
          // Don't trigger checkbox change if clicking on the View details button
          if ((e.target as HTMLElement).closest('button')) {
            return;
          }
          onCheckboxChange?.(!isChecked);
        }}
      >
        {/* Checkbox - appears on hover */}
        <ContentCheckbox
          isChecked={isChecked}
          isShared={isShared}
          onCheckboxChange={onCheckboxChange}
        />

        {/* Image Section */}
        <ContentImageSection content={content} interactive={interactive} />

        {/* Creator Info Section */}
        <CreatorInfoSection
          content={content}
          showMetrics={showMetrics}
          onClick={onClick}
        />
      </div>
    </Tooltip>
  );
};
